import { render, staticRenderFns } from "./PatientTestDetails.vue?vue&type=template&id=0f9f219d&scoped=true"
import script from "./PatientTestDetails.vue?vue&type=script&lang=js"
export * from "./PatientTestDetails.vue?vue&type=script&lang=js"
import style0 from "./PatientTestDetails.vue?vue&type=style&index=0&id=0f9f219d&prod&scoped=true&lang=css"
import style1 from "./PatientTestDetails.vue?vue&type=style&index=1&id=0f9f219d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9f219d",
  null
  
)

export default component.exports